export default __webpack_public_path__ + "static/media/GLM10000-FRONT.36ad7376.jpg";